export default function addChecklistItem (state, checklistItem) {
  state.checklistItems = [...state.checklistItems, checklistItem]
}
